import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { AppNavigator } from "./activities/AppNavigator";
import { API } from "./API";
import AppActionSheets from "./components/Generic/AppActionSheet/AppActionSheets";
import AppModals from "./components/AppModals";
import { AppStateProvider } from "./context/AppStateContext";
import { SocketProvider } from "./context/SocketContext";
import { AppState } from "./system/AppState";
import { ChatSystemStrategies } from "./system/AppState/ChatState";
import { createSocketIOManager } from "./system/SocketIOManager";

interface Props {
  api: API;
  chatSystemStrategies: ChatSystemStrategies;
  pinCode: string | null;
  isAfterRegistration: boolean;
  startWithRequestAgencies: boolean;
  initialShouldMainScreenUpdate: boolean;
  shouldShowPromotionalPopover: boolean;
  onUserLocked: () => void;
  onLogout: () => void;
  onAppNeedsUpdate: () => void;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      retry: 0,
    },
  },
});

function App(props: Props) {
  const [realTimeManager] = React.useState(() => createSocketIOManager(props.api));
  const [appState] = React.useState(() => new AppState(props.api, realTimeManager));

  return (
    <QueryClientProvider client={queryClient}>
      <SocketProvider value={realTimeManager}>
        <AppStateProvider value={appState}>
          <AppNavigator {...props} appState={appState} />
          <AppModals />
          <AppActionSheets />
        </AppStateProvider>
      </SocketProvider>
    </QueryClientProvider>
  );
}

export default App;
